import axios, { AxiosResponse } from 'axios'
import { NotaAtendimentos } from './_models'

const API_URL = process.env.REACT_APP_API_URL
const FINANCEIRO_NOTA_URL = `${API_URL}/financeiro/nota`
const FINANCEIRO_NOTA_ATENDIMENTOSL_URL = `${FINANCEIRO_NOTA_URL}/atendimento`
const FINANCEIRO_NOTAS_PROFISSIONAL_URL = `${FINANCEIRO_NOTA_URL}/profissional/atendimento`

/**
 * Busca atendimentos de uma nota
 * @param idNota ID da nota
 * @returns NotaAtendimentos
 */
export const getAtendimentosByNota = (idNota: number): Promise<NotaAtendimentos> => {
  return axios
    .get(`${FINANCEIRO_NOTA_ATENDIMENTOSL_URL}/${idNota}`)
    .then((resp: AxiosResponse<NotaAtendimentos>) => resp.data)
}

/**
 * Busca atendimentos de uma nota de profissional
 * @param idNota ID da nota
 * @returns NotaAtendimentos
 */
export const getAtendimentosByNotaByProfissional = (idNota: number): Promise<NotaAtendimentos> => {
  return axios
    .get(`${FINANCEIRO_NOTAS_PROFISSIONAL_URL}/${idNota}`)
    .then((resp: AxiosResponse<NotaAtendimentos>) => resp.data)
}
